import http from '@/assets/common/http';
// 控制功能按钮
export function frontEndFun(data) {
  const params = {
    SERVICE_ID: '10060',
    OTYPE: 1,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/frontFun.js